export default "__VITE_ASSET__DHDm3Y0e__"